export const availabilityConstants = {
   
    GETALLAVAILBILITYS_REQUEST: "AVAILBILITYS_GETALL_REQUEST",
    GETALLAVAILBILITYS_SUCCESS: "AVAILBILITYS_GETALL_SUCCESS",
    GETALLAVAILBILITYS_FAILURE: "AVAILBILITYS_GETALL_FAILURE",

    
};
